module.exports = __webpack_public_path__ + "static/media/imgpsh_fullsize_anims.812a2a26.png";